import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { AttachmentSvg } from './AttachmentSvg'

export const NeAttachmentIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={AttachmentSvg} {...props} />
)
